module.exports = __webpack_public_path__ + "img/qu_gb-eng.c6f4299.jpg";